import { useCallback, useSyncExternalStore } from "react";

export const usePortalAnchor = (id: string): HTMLElement | null => {
  const subscribe = useCallback(
    (callback: () => void) => {
      // If element already exists, no need to observe
      if (document.getElementById(id)) {
        return () => {};
      }
      const observer = new MutationObserver(() => {
        if (document.getElementById(id)) {
          observer.disconnect();
          callback();
        }
      });
      observer.observe(document.body, { childList: true, subtree: true });
      return () => observer.disconnect();
    },
    [id],
  );

  const getElement = useCallback(() => document.getElementById(id), [id]);

  return useSyncExternalStore(subscribe, getElement);
};
